



















import { Component, Model, Prop, Vue } from "vue-property-decorator";
import DfiSelectMultiple from "../DfiForm/DfiSelectMultiple.vue";
import { Metric } from "@/types/vesselComparison";

@Component({
  components: {
    DfiSelectMultiple,
  },
})
export default class VesselSelect extends Vue {
  @Model("update:modelValue") metrics!: Metric[];
  @Prop({ required: true }) metricsList!: Metric[];
  @Prop({ default: false }) opened!: boolean;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: false }) loading!: boolean;

  valueFormatter(selected: number) {
    if (selected === 0) return "";

    return `${selected} metric${selected > 1 ? "s" : ""} selected`
  }

  onMetricChange(metrics: Metric[]) {
    this.$emit("update:modelValue", metrics);
  }
}
